import { CrudService } from './CrudService';
import { AxiosPromise } from 'axios';
import { resources } from '../resources';
import { EmployeeDto } from '../models/employees/EmployeeDto';
import { WorkplaceQueryParams } from '../params/WorkplaceQueryParams';
import { WorkplaceDto } from '../models/workplace/WorkplaceDto';
import { ReferenceDto } from '../models/employees/ReferenceDto';
import { AxiosConfig } from './BaseService';
import { BaseSearchParams } from '../params/BaseSearchParams';
import { TrainingDto } from '../models/training/TrainingDto';
import { UpdateContainerOrder } from '../models/workplace/UpdateContainerOrder';

export class WorkplaceService extends CrudService<WorkplaceDto, WorkplaceQueryParams> {
  constructor() {
    super({
      query: resources.queryWorkplace,
      get: resources.getWorkplace,
      create: resources.createWorkplace,
      update: resources.updateWorkplace,
      idKey: 'workplaceId',
    });
  }

  public async getWorkplaceNotificationEmployees(workplaceIds: string[]): AxiosPromise<EmployeeDto[]> {
    return this.get<EmployeeDto[]>(resources.getWorkplaceNotificationEmployees, { workplaceIds: workplaceIds });
  }

  public async addTrainingToWorkPlace(workplaceId: string, referenceDto: ReferenceDto, options: AxiosConfig = {}): AxiosPromise<void> {
    return this.post<void>(resources.addTrainingToWorkPlace, referenceDto, { workplaceId: workplaceId }, options);
  }

  public async getTrainingsByWorkplace(workplaceId: string, args?: BaseSearchParams, options: AxiosConfig = {}): AxiosPromise<TrainingDto[]> {
    return this.get<TrainingDto[]>(resources.getTrainingsByWorkplace, { ...args, workplaceId: workplaceId }, options);
  }

  public async changeTrainingOrder(
    workplaceId: string,
    updateContainerOrder: UpdateContainerOrder,
    options: AxiosConfig = {}
  ): AxiosPromise<TrainingDto[]> {
    return this.put<TrainingDto[]>(resources.changeTrainingOrder, updateContainerOrder, { workplaceId: workplaceId }, options);
  }

  public async removeTrainingFromWorkplace(workplaceId: string, trainingId: string, options: AxiosConfig = {}): AxiosPromise<TrainingDto[]> {
    return this.delete<TrainingDto[]>(resources.removeTrainingFromWorkplace, { workplaceId: workplaceId, id: trainingId }, options);
  }
}
